import { ResumeData } from ".";

export const mastersunionSample: ResumeData = {
  "basics": {
    "url": {
      "href": "https://www.linkedin.com",
      "label": ""
    },
    "name": "John Doe",
    "email": "xyz@gmail.com",
    "phone": "+91 124 456 7890",
    "picture": {
      "url": "",
      "size": 64,
      "effects": {
        "border": false,
        "hidden": false,
        "grayscale": false
      },
      "aspectRatio": 1,
      "borderRadius": 0
    },
    "headline": "",
    "location": "",
    "customFields": []
  },
  "metadata": {
    "css": {
      "value": ".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
      "visible": false
    },
    "page": {
      "format": "a4",
      "margin": 18,
      "options": {
        "breakLine": true,
        "pageNumbers": true
      }
    },
    "notes": "",
    "theme": {
      "text": "#000000",
      "primary": "#000000",
      "background": "#ffffff"
    },
    "layout": [
      [
        [
          "summary",
          "internship",
          "experience",
          "projects",
          "certifications",
          "extracurriculars",
          "languages",
          "skills",
          "education"
        ],
        [
          "profiles",
          "interests",
          "volunteer",
          "references",
          "awards",
          "publications"
        ]
      ]
    ],
    "template": "mastersunion",
    "typography": {
      "font": {
        "size": 10.5,
        // "family": "Times New Roman",
        "family": "Calibri",
        "subset": "latin",
        "variants": [
          "regular"
        ]
      },
      "hideIcons": false,
      "lineHeight": 1.5,
      "underlineLinks": true
    }
  },
  "sections": {
    "awards": {
      "id": "awards",
      "name": "Achievements",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "custom": {},
    "skills": {
      "id": "skills",
      "name": "Skills",
      "items": [
        {
          "id": "uyaav7eukhwm8zh29pbd798e",
          "name": "Languages C++, Java, JavaScript",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": ""
        },
        {
          "id": "rxa4t6s51gc3lzbhmzcmyyn2",
          "name": "Technologies/Frameworks",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": "Angular, Jasmine Testing, React JS, Node JS, Git, GitHub, Ubuntu"
        },
        {
          "id": "x7erri63q77d3bmk8puubrvj",
          "name": "Domain Skills",
          "level": 1,
          "visible": true,
          "keywords": [],
          "description": "Data Structures and Algorithms, Problem-Solving, Responsive Web Design, Scripting in Python and JavaScript"
        }
      ],
      "columns": 1,
      "visible": true
    },
    "summary": {
      "id": "summary",
      "name": "Summary",
      "columns": 1,
      "content": "",
      "visible": true
    },
    "profiles": {
      "id": "profiles",
      "name": "Profiles",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "projects": {
      "id": "projects",
      "name": "Projects",
      "items": [
        {
          "id": "pdm2utva6fdw9od9oza1f38e",
          "url": {
            "href": "",
            "label": ""
          },
          "date": "Jul 2022 - Aug 2022",
          "name": "Fkart App | MERN Stack, Responsive Web Design",
          "summary": "<ul><li><p>Developed an e-commerce platform wherein users can buy numerous products such as electronics, clothing, and more.</p></li><li><p>It offers dynamic data from MongoDB, responsive design, dynamic pagination based on data, and developer REST APIs</p></li><li><p>for insertion, retrieval, deletion of data, user authentication, individual user data storage, and other advanced tasks.</p></li><li><p>Applied MERN stack knowledge successfully to create a fully functional MERN stack website.</p></li><li><p>Repository Link: <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://github.com/suraj-singh12/flipkart-project\">https://github.com/suraj-singh12/flipkart-project</a></p></li></ul>",
          "visible": true,
          "keywords": [],
          "location": "",
          "description": ""
        },
        {
          "id": "f3ngsrd0s764o7c3o2lr0s8b",
          "url": {
            "href": "",
            "label": ""
          },
          "date": "Feb 2021 - Mar 2023",
          "name": "Project SearchEverywhere | Python3, Linux, Grep, Open Office, Bash, MS Office",
          "summary": "<ul><li><p>Designed an open-source Linux tool that allows users to search for specific information in multiple file of types including documents, presentations, spreadsheets, and text files.</p></li><li><p>This is an enhancement to the ‘grep‘ command on Linux systems which only allows searching in text files only.</p></li><li><p>Used extensively by students for preparation of university exams during COVID-19 times.</p></li><li><p>Repository Link: <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://github.com/suraj-singh12/Project-SearchEverywhere\">https://github.com/suraj-singh12/Project-SearchEverywhere</a></p></li></ul>",
          "visible": true,
          "keywords": [],
          "location": "",
          "description": ""
        }
      ],
      "columns": 1,
      "visible": true
    },
    "education": {
      "id": "education",
      "name": "Education",
      "items": [
        {
          "id": "rqitwngoou5bfngnxu9ft9w8",
          "visible": true,
          "institution": {
            "label": "Lovely Professional University",
            "href": ""
          },
          "program": "",
          "studyType": "Bachelor of Technology - Computer Science and Engineering ",
          "area": "Phagwara, Punjab",
          "score": "CGPA: 9.23",
          "date": "2020 – 2024",
          "summary": "",
          "highlights": "",
          "url": {
            "href": "",
            "label": ""
          }
        },
        {
          "id": "xlkwvr1f0otumx0ettvph4ip",
          "url": {
            "href": "",
            "label": ""
          },
          "area": "",
          "date": "2018 – 2019",
          "score": "",
          "summary": "",
          "visible": true,
          "program": "",
          "studyType": "12th — Percentage: 94.60%",
          "institution": {
            "label": "Kendriya Vidyalaya",
            "href": ""
          }
        },
        {
          "id": "tin01sh1p5pd4cbroyen8fr4",
          "url": {
            "href": "",
            "label": ""
          },
          "area": "Shahjahanpur, Uttar Pradesh",
          "date": "2016 – 2017",
          "score": "",
          "summary": "",
          "visible": true,
          "program": "",
          "studyType": "10th — CGPA: 10",
          "institution": {
            "label": "Kendriya Vidyalaya Shahjahanpur Cantt",
            "href": ""
          }
        }
      ],
      "columns": 1,
      "visible": true
    },
    "interests": {
      "id": "interests",
      "name": "Interests",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "languages": {
      "id": "languages",
      "name": "Languages",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "volunteer": {
      "id": "volunteer",
      "name": "Volunteering",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "extracurriculars": {
      "id": "extracurriculars",
      "name": "Extra-curriculars",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "experience": {
      "id": "experience",
      "name": "Experience",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "internship": {
      "id": "internship",
      "name": "Internship",
      "items": [
        {
          "id": "l3peeemxc2zmnmlp9t40tqsz",
          "date": "May 2023 - Jul 2023",
          "company": {
            "label": "JP Morgan Chase & Co.",
            "href": "https://www.jpmorganchase.com"
          },
          "companyDescription": "Global Financial Services Firm",
          "summary": "<p><b><i><u>Responsibilities</u></i></b></p><ul><li>Contributed to the advancement of the organization's robust Document Manager web application.</li><li>Improved user experience and productivity by implementing comprehensive row grouping, column filtering, and data filtering functionality using Angular Ag-Grid.</li><li>Enhanced application performance, improved records' load time, and increased overall efficiency by implementing server-side pagination and nested child pagination.</li><li>Wrote Angular unit test cases using the Jasmine framework to validate the responsiveness of the grid on different resolutions.</li></ul>",
          "visible": true,
          "location": "Mumbai, India",
          "position": "SEP Intern"
        },
        {
          "id": "zphhnrdesalgeu1lgca9abhq",
          "date": "Feb 2022 - Aug 2023",
          "company": {
            "label": "Edureka",
            "href": "https://www.edureka.co"
          },
          "companyDescription": "Online Learning Platform",
          "summary": "<p><b><i><u>Responsibilities</u></i></b></p><ul><li>Built two dynamic web applications, Flipkart Clone and Zomato Clone, leveraging the power of the MERN stack.</li><li>Automated web data collection through software tools and custom scripts, streamlining repetitive tasks effectively.</li><li>Collaborated with senior developers to implement best practices in code quality and performance optimization.</li></ul>",
          "visible": true,
          "location": "Remote",
          "position": "Full Stack Web Developer Intern"
        }
      ],
      "columns": 1,
      "visible": true
    },
    "references": {
      "id": "references",
      "name": "References",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "publications": {
      "id": "publications",
      "name": "Publications",
      "items": [],
      "columns": 1,
      "visible": true
    },
    "certifications": {
      "id": "certifications",
      "name": "Certificate / Certifications",
      "items": [
        {
          "id": "angpnefgj17vi9gjkys7blzs",
          "url": {
            "href": "https://www.udemy.com/",
            "label": ""
          },
          "date": "",
          "name": "Full Stack Web Development",
          "issuer": "Udemy",
          "summary": "",
          "visible": true
        },
        {
          "id": "f6x3wpfkxfok06cbv5o4pbq2",
          "url": {
            "href": "https://www.udemy.com/",
            "label": ""
          },
          "date": "",
          "name": "Linux for Developers Mar 2021",
          "issuer": "Udemy",
          "summary": "",
          "visible": true
        }
      ],
      "columns": 1,
      "visible": true
    }
  }
};

